export const Sizes = {
	XS: 'xs',
	S: 's',
	M: 'm',
	L: 'l',
	XL: 'xl',
	'2XL': '2xl',
	'3XL': '3xl',
} as const;
